import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { FilterCreatureComponent } from '../../list/components/filter/filter-creature.component';
import { ItemCreatureComponent } from '../../list/components/item/item-creature.component';
import { CreatureLiteWebDto } from '../../../../../dtos/creature.lite.web.dto';
import { CreaturesService } from '../../../../../services/creatures.service';
import { CreatureWebFilterDto } from '../../../../../dtos/creature.web.filter.dto';
import { CommonModule } from '@angular/common';
import { CreatureSortType } from '../../../../../enums/creature-sort.type';
import { CreatureWebDto } from '../../../../../dtos/creature.web.dto';

@Component({
    selector: 'breeding-list-creature-popup',
    templateUrl: './breeding-list-creature.popup.html',
    styleUrl: './breeding-list-creature.popup.scss',
    imports: [
        CommonModule,
        FilterCreatureComponent,
        ItemCreatureComponent
    ],
    providers: [
        CreaturesService
    ]
})
export class BreedingListCreaturePopup implements OnInit {

    @Input() show: boolean = false;
    @Output() showChange = new EventEmitter<boolean>();

    @Input() creatureRef!: CreatureWebDto;

    @Input()
    public selectCreature: ((creature: CreatureLiteWebDto) => void) | null = null;

    public countOfFilterChanged: number = 0;
    public showLoading: boolean = false;
    public hasMore: boolean = true;

    public filter: CreatureWebFilterDto = {
        onlyMy: true,
        onlyForTrade: false,
        availableForBreeding: true,
        minHp: null,
        maxHp: null,
        minLevel: null,
        maxLevel: null,
        minPrice: null,
        maxPrice: null,
        isChildren: false,
        isParent: false,
        abilityIds: [],
        ignoreIds: [],
        nftTokenIds: [],
        nftParentTokenId: null,
        types: [],
        rarities: [],
        page: 0,
        pageSize: 20,
        sortBy: CreatureSortType.PriceAsc
    };

    public creatures: CreatureLiteWebDto[] | null = null;

    constructor(private readonly creaturesService: CreaturesService) {

    }

    closePopup() {
        this.show = false;
        this.showChange.emit(this.show);
    }

    ngOnInit(): void {
        this.onFilterChange();
    }

    onFilterChange() {
        this.showLoading = true;
        this.filter.ignoreIds = [this.creatureRef.id];
        this.creaturesService.getByFilter(this.filter).subscribe({
            next: (newCreatures) => {
                if (newCreatures.length === 0) {
                    this.hasMore = false;
                } else {
                    this.creatures = [...(this.creatures ?? []), ...newCreatures];
                }
                this.showLoading = false;
            },
            error: (err) => {
                console.error('Failed to load creatures:', err);
                this.showLoading = false;
            },
        });

        this.countOfFilterChanged = 0;
        if (this.filter.minHp) {
            this.countOfFilterChanged++;
        }
        if (this.filter.maxHp) {
            this.countOfFilterChanged++;
        }
        if (this.filter.minLevel) {
            this.countOfFilterChanged++;
        }
        if (this.filter.maxLevel) {
            this.countOfFilterChanged++;
        }
        if (this.filter.minPrice) {
            this.countOfFilterChanged++;
        }
        if (this.filter.maxPrice) {
            this.countOfFilterChanged++;
        }
        if (this.filter.abilityIds && this.filter.abilityIds.length > 0) {
            this.countOfFilterChanged++;
        }
        if (this.filter.types && this.filter.types.length > 0) {
            this.countOfFilterChanged++;
        }
        if (this.filter.rarities && this.filter.rarities.length > 0) {
            this.countOfFilterChanged++;
        }
    }

    async onScroll(event: Event) {
        const target = event.target as HTMLElement;
        if (this.showLoading || !this.hasMore) return;

        const threshold = 150;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - threshold) {
            this.filter.page++;
            await this.onFilterChange();
        }
    }

    onSelectCreature(creature: CreatureLiteWebDto) {
        this.selectCreature?.call(this, creature);
    }

}
